import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@cue/ui';
import {
  cueClose,
  cueExclamation,
  cueNavigationCircle,
  cuePencil,
  cueStart,
  cueTarget,
  IconComponent,
} from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';

// http://localhost:4201/navigation?areaId=27&targetResourceId=503&wantOnlyBarrierFreePaths=true&startResourceId=490
@Component({
  selector: 'cue-same-target-start-dialog',
  imports: [ButtonComponent, IconComponent, TranslocoPipe],
  templateUrl: './same-target-start-dialog.component.html',
  styleUrl: './same-target-start-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SameTargetStartDialogComponent {
  primary = input<'target' | 'start'>();
  canChangeOnlyTarget = input<boolean>(false);
  ICONS = {
    cueClose,
    cueExclamation,
    cuePencil,
    cueNavigationCircle,
    cueStart,
    cueTarget,
  };

  changeTarget = output();
  changeStart = output();

  protected readonly translation = translation;
}
